import { authQueryKeys as e } from "../state/useAuthQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { authApi as r } from "@maat/api-main";
//#region src/queries/login/useLogoutMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.logout,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.state() }), i.invalidateQueries({ queryKey: e.me() }), i.removeQueries({ queryKey: ["permission"] });
		}
	});
};
//#endregion
export { i as useLogoutMutation };
